import { useSyncExternalStore } from "react";

const query = "(max-width: 1024px)";

function subscribe(callback: () => void) {
  const mql = window.matchMedia(query);
  mql.addEventListener("change", callback);
  return () => mql.removeEventListener("change", callback);
}

function getSnapshot() {
  return window.matchMedia(query).matches;
}

export function useIsNarrow() {
  return useSyncExternalStore(subscribe, getSnapshot, () => false);
}
